import bgImage from "../../assets/landingBg.png";

const UnsubscribePage = () => {
  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    padding: "20px",
    backgroundColor: "#009fd9",
    backgroundImage: `url(${bgImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  };

  const cardStyle = {
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    backdropFilter: "blur(6px)",
    WebkitBackdropFilter: "blur(6px)",
    padding: "10px",
    borderRadius: "16px",
    border: "1px solid rgba(255, 255, 255, 0.2)",
    textAlign: "center",
    maxWidth: "550px",
    width: "100%",
    boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
  };

  const titleStyle = {
    marginBottom: "15px",
    fontWeight: "bold",
    color: "#fff",
  };

  const pStyle = {
    margin: "0",
    fontWeight: "bold",
    color: "#fff",
    lineHeight: "1.5",
  };

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <h2 style={titleStyle}>Unsubscribe successful!</h2>
        <p style={pStyle}>
          Your unsubscribe request has been successfully accepted!
        </p>
      </div>
    </div>
  );
};

export default UnsubscribePage;
